import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('consignments', 'Lô hàng');

const state = {
    ...crud.state,
    selected: {BigPackages: []},
    available_bigpackages: []
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getBigPackageList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('available_bigpackages', data => {
            commit('setBigPackageList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    }
};
const mutations = {
    ...crud.mutations,
    setBigPackageList(state, ret) {
        state.available_bigpackages = ret.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};